import React from 'react';
import c from 'classnames';

import { SearchResults } from '@uncinc/react-searchkit';
import type { Results } from '@uncinc/react-searchkit/types';

import EmptyState from './EmptyState';
import EventHit from './EventHit';
import NewsHit from './NewsHit';
import OnlineCourseHit from './OnlineCourseHit';
import OrganizationHit from './OrganizationHit';
import PageHit from './PageHit';
import PracticalMaterialHit from './PracticalMaterialHit';
import PublicationHit from './PublicationHit';
import type {
  SearchAllContentEventHit,
  SearchAllContentHit,
  SearchAllContentNewsHit,
  SearchAllContentOnlineCourseHit,
  SearchAllContentOrganizationHit,
  SearchAllContentPageHit,
  SearchAllContentPracticalMaterialHit,
  SearchAllContentPublicationHit,
} from '../types';

import './style.scss';

const RenderItem = (hit: SearchAllContentHit) => {
  const { type } = hit;

  switch (type[0]) {
    case 'biblio': {
      return <PublicationHit hit={hit as SearchAllContentPublicationHit} />;
    }

    case 'practical_material': {
      return <PracticalMaterialHit hit={hit as SearchAllContentPracticalMaterialHit} />;
    }

    case 'online_course': {
      return <OnlineCourseHit hit={hit as SearchAllContentOnlineCourseHit} />;
    }

    case 'event': {
      return <EventHit hit={hit as SearchAllContentEventHit} />;
    }

    case 'news': {
      return <NewsHit hit={hit as SearchAllContentNewsHit} />;
    }

    case 'organization': {
      return <OrganizationHit hit={hit as SearchAllContentOrganizationHit} />;
    }

    case 'page':
    default: {
      return <PageHit hit={hit as SearchAllContentPageHit} />;
    }
  }
};

const SearchAllContentResults: React.FC<Omit<Results, 'renderItem' | 'emptyState'>> = (props) => {
  const { className } = props;

  const classNames = c('Search__Results', 'SearchAllContent__Results', className);

  return (
    <SearchResults
      className={classNames}
      renderItem={RenderItem}
      emptyState={<EmptyState />}
    />
  );
};

export default SearchAllContentResults;
